import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import injectSheet from "react-jss";
import axios from "axios";
import { useIntl } from "react-intl";
import { groupBy, last, orderBy } from "lodash";

import TimeLineItem from "../../../../detalhes-lead/TimeLine/TimeLineItem/TimeLineItem";
import { Flex, Loading, Tipografia } from "../../../../../_common";

const style = () => ({
  titulo: { paddingBottom: 5 },
  tituloData: {
    paddingBottom: 8,
    paddingTop: 8,
    paddingLeft: 20,
    color: "#000000DE",
  },
});

function TimeLineAtividades({ lead, classes }) {
  const intl = useIntl();
  const [timelineItems, setTimelineItens] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      const { data } = await axios.get(`/api/pipeline/lead/timeline`, {
        params: { id: lead.id, buscarTipo: 0 },
      });
      if (data.timelineItens) setIsLoading(false);
      setTimelineItens(data.timelineItens);
    };

    fetchData();
  }, []);

  const renderItems = (items, orders, ultimoAgrupamento) =>
    orderBy(items, ["dataTimeStamp", "atividadeId"], orders).map(evento => (
      <TimeLineItem
        timelineItens={items}
        key={evento.id}
        itemTimeline={evento}
        ultimo={evento === last(orderBy(items, "dataTimeStamp", orders)) && ultimoAgrupamento}
        index={evento.posicaoLista}
        lead={lead}
        isTimelineAtividades
      />
    ));

  const renderQuadro = (titulo, timelineItemsAtividade, orders, agruparPorPeriodo) => (
    <div key={titulo}>
      <Flex style={{ paddingBottom: !agruparPorPeriodo ? 16 : 0 }}>
        <Tipografia tipo="tituloCard" className={classes.titulo}>
          {titulo}
        </Tipografia>
      </Flex>

      {agruparPorPeriodo &&
        Object.keys(timelineItemsAtividade).map((key, index) => (
          <div key={key}>
            <Flex>
              <div style={{ width: 106, borderRight: index !== 0 ? "2px solid #D9D9D9" : "none" }} />
              <Tipografia tipo="subtituloConteudo" className={classes.tituloData}>
                {key}
              </Tipografia>
            </Flex>
            {renderItems(timelineItemsAtividade[key], orders, index === Object.keys(timelineItemsAtividade).length - 1)}
          </div>
        ))}

      {!agruparPorPeriodo && renderItems(timelineItemsAtividade, orders, true)}
    </div>
  );

  const timelineItemAtividades = () => {
    const listaSomenteAtividade = (timelineItems || []).filter(timelineItem => timelineItem.tipoTimeline === 1);
    return listaSomenteAtividade;
  };

  const timelineItemEventosAgrupada = () => {
    const listaSomenteEvento = orderBy(
      (timelineItems || []).filter(timelineItem => [0, 2, 3].includes(timelineItem.tipoTimeline)),
      "dataTimeStamp",
      "desc"
    );

    return groupBy(orderBy([...listaSomenteEvento], "dataTimeStamp", "desc"), "periodo");
  };

  return (
    <>
      <div className={classes.timeline}>
        <Loading isLoading={isLoading} />

        {Object.keys(timelineItemAtividades()).length > 0 &&
          renderQuadro(
            intl.formatMessage({
              defaultMessage: "Próximas ações",
            }),
            timelineItemAtividades(),
            "asc",
            false
          )}

        {Object.keys(timelineItemEventosAgrupada()).length > 0 &&
          renderQuadro(
            intl.formatMessage({
              defaultMessage: "Histórico",
            }),
            timelineItemEventosAgrupada(),
            "desc",
            true
          )}
      </div>

      {!isLoading &&
        timelineItems.length === 0 && (
          <Flex center style={{ paddingTop: 64 }}>
            <Tipografia cor="darkSecondaryText">
              {intl.formatMessage({ defaultMessage: "Não há ações para serem listadas" })}
            </Tipografia>
          </Flex>
        )}
    </>
  );
}

TimeLineAtividades.propTypes = {
  lead: PropTypes.object,
};

const enhance = compose(injectSheet(style));

export default enhance(TimeLineAtividades);
